import {
  GET_NEW_ORDERS,
  GET_ACCEPTED_ORDERS,
  GET_DELIVERY_PENDING_ORDERS,
  GET_DELIVERING_ORDERS,
  ACCEPTING_ORDER,
  REJECTING_ORDER,
  ASSIGN_ORDER,
} from "./Types";

import url from "../constants/URL.js";

const token = JSON.parse(localStorage.getItem("persist:auth")).token;

export const getNewOrders = (id) => (dispatch) => {
  fetch(`${url}/orders/new/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then(async (resp) => {
      const data = await resp.json();
      if (!data.e) {
        dispatch({
          type: GET_NEW_ORDERS,
          payload: data,
        });
      }
    })
    .catch((e) => {
      throw new Error(e);
    });
};

export const getAcceptedOrders = (id) => (dispatch) => {
  fetch(`${url}/orders/accepted/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then(async (resp) => {
    const data = await resp.json();
    if (!data.e) {
      dispatch({
        type: GET_ACCEPTED_ORDERS,
        payload: data,
      });
    }
  });
};

export const getPendingToDeliver = (id) => async (dispatch) => {
  fetch(`${url}/orders/pending/delivery/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then(async (resp) => {
    const data = await resp.json();

    if (!data.e) {
      dispatch({
        type: GET_DELIVERY_PENDING_ORDERS,
        payload: data,
      });
    }
  });
};

export const getDeliveringOrders = (id) => (dispatch) => {
  fetch(`${url}/orders/delivering/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then(async (resp) => {
    const data = await resp.json();
    if (!data.e) {
      dispatch({
        type: GET_DELIVERING_ORDERS,
        payload: data,
      });
    }
  });
};

export const acceptingOrder =
  (orderID, mins, hours, days) => async (dispatch) => {
    const time = { mins, hours, days };
    fetch(`${url}/order/${orderID}/accepted`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(time),
    }).then(async (res) => {
      const response = await res.json();
      if (response.msg === "Order Accepted") {
        dispatch({
          type: ACCEPTING_ORDER,
          payload: { orderID, preparationTime: { mins, hours, days } },
        });
      }
    });
  };

export const rejectingOrder = (orderID, reason) => async (dispatch) => {
  fetch(`${url}/order/${orderID}/rejected`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ reason }),
  }).then((res) => {
    if (res === "Order Rejected") {
      dispatch({
        type: REJECTING_ORDER,
        payload: orderID,
      });
    }
  });
};

export const assignOrder =
  (orderID, deliveryboyID, tcs) => async (dispatch) => {
    fetch(`${url}/assign/${orderID}/to/${deliveryboyID}/?tcs=${tcs}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then(() => {
      dispatch({
        type: ASSIGN_ORDER,
        payload: orderID,
      });
    });
  };
